module.exports = __webpack_public_path__ + "img/calendario.a6562f6d.svg";